import { useEffect, useState } from 'react'

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-orange-50/80 via-white to-white"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gradient-to-b from-orange-100/40 to-transparent rounded-full blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto px-6 pt-16 pb-12 sm:pt-20 sm:pb-16">
        <div
          className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="text-center">
            <span className="inline-block text-orange-500 font-semibold text-lg mb-6">优查查</span>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
              个人与企业信息查询平台
            </h1>

            <p className="text-base sm:text-lg text-gray-500 max-w-xl mx-auto mb-8">
              在用户授权前提下，向第三方机构请求信息并进行查询展示
            </p>

            <p className="text-sm text-gray-400 max-w-md mx-auto">
              平台仅对信息进行查询、整理与展示，不提供任何判断、评估或建议
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
